import type { Cookie } from '../model';

export type SessionKeyPersistence = (cookie: Required<Cookie>) => void | Promise<void>;

let registeredPersistence: SessionKeyPersistence | undefined;

export function registerSessionKeyPersistence(persistence: SessionKeyPersistence) {
  registeredPersistence = persistence;
}

export function hasSessionKeyPersistence(): boolean {
  return typeof registeredPersistence === 'function';
}

export async function persistCartSessionKey(cookie: Required<Cookie>): Promise<void> {
  if (registeredPersistence) {
    await registeredPersistence(cookie);
  }
}
